// extracted by mini-css-extract-plugin
module.exports = {"root":"nHglQAQDfDo1kqgLUuV1","title":"pmW_HRsDSzplTJT8va9g"};